import React, {useState} from 'react';
import {useIntl} from 'react-intl';
import MediaPreview from './MediaPreview';
import ButtonAction from '../../../../../_common/components/ButtonAction';
import ModalContainer from '../../../../../_common/components/ModalContainer';
import ModalHeader from '../../../../../_common/components/ModalHeader';
import ModalButtonsContainer from '../../../../../_common/components/ModalButtonsContainer';
import ModalContent from '../../../../../_common/components/ModalContent';
import {buttonCancel, largeButtonsPadding} from '../../../../../_common/styles/styles';
import styles from './styles.module.scss';

interface FileNamePreviewProps {
  orderID: number;
  fileExtension: string,
  fileName: string,
}

const FileNamePreview = ({fileName, fileExtension, ...rest}: FileNamePreviewProps) => {
  const [open, setOpen] = useState(false);
  const openPopup = () => setOpen(true);
  const closePopup = () => setOpen(false);
  const {formatMessage} = useIntl();

  return (
    <>
      <ButtonAction
        variant={'success'}
        label={fileName}
        useIcon={'/media/common/Eye_white.svg'}
        onClick={openPopup}
      />
      <ModalContainer show={open} onHide={closePopup} size={'xl'}>
        <>
          <ModalHeader type={'complex'} header={fileName} icon={'/media/common/Eye_primary.svg'}/>
          <ModalContent customClassnames={styles.modalBody}>
            <div className={styles.previewPanel}>
              <MediaPreview fileName={fileName} fileExtension={fileExtension} {...rest}/>
            </div>
          </ModalContent>
          <ModalButtonsContainer customClassnames={largeButtonsPadding}>
            <ButtonAction
              variant={'cancel'}
              onClick={closePopup}
              label={formatMessage({id: 'tab-order-inspections-tasks-button-close', defaultMessage: 'Close'})}
              customClassnames={buttonCancel}
            />
          </ModalButtonsContainer>
        </>
      </ModalContainer>
    </>
  );
};

export default FileNamePreview;